function IconClock({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100"
      height="100"
      viewBox="0 0 1418 1304"
      fill="currentColor"
      className={className}
      style={{
        clipRule: 'evenodd',
        fillRule: 'evenodd',
        strokeLinejoin: 'round',
        strokeMiterlimit: 1,
        version: 1,
      }}
    >
      <path d="M708.4 21.6c353.7 0 640.9 284.6 640.9 635.1 0 350.5-287.2 635.1-640.9 635.1 -353.7 0-640.9-284.6-640.9-635.1 0-350.5 287.2-635.1 640.9-635.1Zm1.3 127.3c282.9 0 512.6 226.9 512.6 506.3 0 279.5-229.7 506.3-512.6 506.3 -282.9 0-512.6-226.9-512.6-506.3 0-279.5 229.7-506.3 512.6-506.3Z" />
      <path d="M761.6 263.6c0-18.3-14.9-33.1-33.1-33.1l-66.3 0c-18.3 0-33.1 14.9-33.1 33.1l0 426.8c0 18.3 14.9 33.1 33.1 33.1l66.3 0c18.3 0 33.1-14.9 33.1-33.1l0-426.8Z" />
      <path d="M977.7 723.7c18.3 0 33.1-14.9 33.1-33.1l0-66.3c0-18.3-14.9-33.1-33.1-33.1l-316.6 0c-18.3 0-33.1 14.9-33.1 33.1l0 66.3c0 18.3 14.9 33.1 33.1 33.1l316.6 0Z" />
    </svg>
  );
}

export default IconClock;
